module.exports = __webpack_public_path__ + "static/media/pro-mini-assistant-bg.b5db225e.png";